module.exports = __webpack_public_path__ + "img/ic_banner_arrow_next.cd699d88.svg";